// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2_nq4","footer":"ReportModalFilter_footer__3waKS"};